import React from 'react';
import { View } from 'react-native';
import Input from '../../../elements/inputs';

const selectOptions = ['Blog Manager', 'Accouting Manager']

const AssignUserRoles = ({selectedRoles, setSelectedRoles}) => {

  return (
    <View style={{maxWidth: '60vw'}}>
      <Input.MultiSelect
        selected={selectedRoles.map(name => {
          return name
        }) || selectedRoles}
        setSelected={setSelectedRoles}
        resourceType='User Roles'
        resources={selectOptions?.map(userRoleName => {
          return { id: userRoleName, name: userRoleName}
        })}
      />
    </View>
  )
}

export default AssignUserRoles;
